/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { Switch, BrowserRouter, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

// toast
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { GlobalStyle } from 'styles/global-styles';

import { useTranslation } from 'react-i18next';
import ProtectedRoute from 'app/route/ProtectedRoute';
import { authRoutes, userRoutes } from 'app/route/allRoutes';

// layouts Format
import VerticalLayout from 'app/components/VerticalLayout';
import HorizontalLayout from 'app/components/HorizontalLayout';
import NonAuthLayout from 'app/components/NonAuthLayout';

import { TOAST_TIME } from 'app/config';

export function App() {
  const { layoutType } = useSelector(
    (rootState: RootState) => rootState.layout,
  );
  const { i18n } = useTranslation();
  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (layoutType) {
      case 'horizontal':
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }
  const Layout = getLayout();
  return (
    <BrowserRouter>
      <Helmet
        titleTemplate="Admin Panel"
        defaultTitle="Admin Panel"
        htmlAttributes={{ lang: i18n.language }}
      >
        <meta name="description" content="Admin Panel" />
      </Helmet>

      <Switch>
        {authRoutes.map((route, idx) => (
          <ProtectedRoute
            path={route.path}
            layout={NonAuthLayout}
            component={route.component}
            key={idx}
            isAuthProtected={false}
            exact={route.exact}
          />
        ))}
        {userRoutes.map((route, idx) => (
          <ProtectedRoute
            path={route.path}
            layout={Layout}
            component={route.component}
            key={idx}
            isAuthProtected={true}
            exact
          />
        ))}
        <Redirect from="*" to="/notFound" />
      </Switch>
      <ToastContainer
        position="top-right"
        autoClose={TOAST_TIME}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <GlobalStyle />
    </BrowserRouter>
  );
}
